import axios from 'axios';
import { JobOfffer } from './fixcenter-career-job-offer.model';

export const htmlId: string = 'fixcenter-career-form';
export const formContainerHtmlId: string = 'UploadYourResumeHeader';
export const maxWidthDragAndDropFile: number = 500;
export const minHeightDragAndDropFile: number = 50;
export const uploadFileInfo: string = 'UPLOAD_FILE_INFO';
export const extensionFiles: string[] = ['.pdf'];

export function uploadResumeHeader(dto: FormData) {
    return axios.post(`FixcenterCareer/UploadResumeHeader`, dto);
}

export const getLinkToOpenJobOffers = () => {
    return `/Home/OpenJobOffers`;
};

export const getLinkToSalesChauffeurJobOffer = () => {
    return `${getLinkToOpenJobOffers()}/SalesChauffeur`;
};

export const getLinkToRevitDesignerJobOffer = () => {
    return `${getLinkToOpenJobOffers()}/RevitDesigner`;
};

export const getLinkToAccountManagerJobOffer = () => {
    return `${getLinkToOpenJobOffers()}/AccountManager`;
};

export const getLinkToAccountManagerLuxJobOffer = () => {
    return `${getLinkToOpenJobOffers()}/AccountManagerLux`;
};

export const getJoboffers = () => {
    return [
        new JobOfffer('CAREER_ITEMS.HEADER_2', getLinkToSalesChauffeurJobOffer()),
        new JobOfffer('CAREER_ITEMS.HEADER_3', getLinkToRevitDesignerJobOffer()),
        new JobOfffer('CAREER_ITEMS.HEADER_4', getLinkToAccountManagerJobOffer()),
        new JobOfffer('CAREER_ITEMS.HEADER_5', getLinkToAccountManagerLuxJobOffer()),
    ];
};
